import { render, staticRenderFns } from "./FilePreview.vue?vue&type=template&id=62e49d94"
import script from "./FilePreview.vue?vue&type=script&lang=js"
export * from "./FilePreview.vue?vue&type=script&lang=js"
import style0 from "./FilePreview.vue?vue&type=style&index=0&id=62e49d94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports